<div class="d-flex flex-column gap-3 h-100">
  <lib-upload-external-contract
    [dealId]="effectiveDealId()"
    [document]="documents()[0]?.externalSigning ?? null"
    (uploaded)="reloadDocuments()"
  />

  @if (documents()[0]?.externalSigning; as externalSigning) {
    <div class="flex-fill">
      <lib-external-signing
        [document]="externalSigning"
        [documentCategory]="documents()[0]?.documentType ?? 'APS'"
        (replaceRequested)="replaceRequested()"
      />
    </div>
  } @else if (documents().length > 0) {
    <lib-signable-document-card
      signingContext="aps"
      [documents]="documents()"
      (refreshRequested)="reloadDocuments()"
      [origin]="'aps'"
    />
  } @else {
    <lib-doc-generation
      generationContext="aps"
      [dealId]="effectiveDealId()"
      [projectId]="projectId()"
      [contractDetails]="contractDetails()"
      [documentTemplatesInput]="documentTemplates()"
      (templatesChange)="documentTemplates.set($event)"
      (refreshRequested)="reloadDocuments()"
    />
  }
</div>
